export interface NavLeaf {
  label: string
  to: string
  count?: number
  sub?: boolean
}

export interface NavGroup {
  label?: string
  items: NavLeaf[]
}

/** Exact IA from docs/design/00-design-system.md §5 — binding, do not reorder/rename. */
export const NAV_GROUPS: NavGroup[] = [
  {
    items: [
      { label: 'Home', to: '/' },
      // Command Center (M11 FR-LEAD-01/02/03, added post r0-nav-IA freeze) —
      // appended rather than inserted so the binding r0 IA below stays
      // untouched in order/naming.
      { label: 'Command Center', to: '/leadership' },
    ],
  },
  {
    label: 'Fleet',
    items: [
      { label: 'Catalog', to: '/fleet', count: 50 },
      { label: 'Journeys Board', to: '/fleet#journeys', sub: true },
      { label: 'Data-Blindness Board', to: '/fleet#blindness', sub: true },
    ],
  },
  {
    items: [
      // Observability is now the dedicated Metrics portal (portal 1 of 6); the
      // old /observability path redirects to /metrics (App.tsx). Label kept per
      // the binding r0 IA — only the destination moved.
      { label: 'Observability', to: '/metrics' },
      { label: 'Alerts', to: '/alerts' },
      { label: 'Incidents', to: '/incidents' },
      { label: 'Security', to: '/security' },
      { label: 'Customers', to: '/customers' },
      { label: 'Teams', to: '/teams' },
      { label: 'Knowledge', to: '/knowledge' },
      { label: 'AI', to: '/ai' },
      { label: 'Data', to: '/data' },
      { label: 'Admin', to: '/admin' },
      // Developer Workspace (M7 FR-DEV-01, added post r0-nav-IA freeze) —
      // appended rather than inserted so the binding r0 IA above stays
      // untouched in order/naming.
      { label: 'Developer', to: '/terminals' },
      // Pricing module (P2, added post r0-nav-IA freeze) — appended for the
      // same reason as Command Center/Developer above.
      { label: 'Pricing', to: '/pricing' },
      // Infrastructure Fleet (M13 S1/S2, added post r0-nav-IA freeze) —
      // appended for the same reason as Command Center/Developer/Pricing
      // above. Distinct from "Fleet" (Catalog, above): that's the M2 service
      // catalog, this is cell/node infrastructure lifecycle.
      { label: 'Infrastructure', to: '/infrastructure' },
      // Autopilot Command (M14 S4, the SEPARATE dashboard per Founder D8) —
      // appended for the same reason as the entries above. The human cockpit
      // for autonomy: scope map, live grade sheet, A1 inbox, A2/A3 feed, freeze.
      { label: 'Autopilot', to: '/autopilot' },
    ],
  },
]
